// extracted by mini-css-extract-plugin
export default {"root":"ListTabs_root__Mvlfa","tab":"ListTabs_tab__KtzEm","--active":"ListTabs_--active__hbs2o"};